import { Route, Routes } from 'react-router';
import { Main, Login, SignUp, Home } from '../Pages';
import Provider from '../Pages/Provider/provider';
import CreateBusiness from '../Pages/CreateBusiness/createBusiness';
import MyBusiness from '../Pages/My_Business/myBusiness';
import VisitorPage, { VisitorPageContents } from '../Pages/Visitor/Menu/visitorPage';

const Router: React.FC = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={
                    <Main />
                }
            />
            <Route
                path='/login'
                element={
                    <Login />
                }
            />
            <Route
                path='/signUp'
                element={
                    <SignUp />
                }
            />
                <Route
                    path='/:name/menu/:id/:locationType?/:locationNumber?'
                    element={
                        <VisitorPage/>
                    }
                />
            <Route
                path='/home'
                element={
                    <Provider
                        children={<Home />}
                    />
                }
            />
             <Route
                path='/create_business'
                element={
                    <Provider
                        children={<CreateBusiness />}
                    />
                }
            />
             <Route
                path='/my_business/:id'
                element={
                    <Provider
                        children={<MyBusiness />}
                    />
                }
            />
        </Routes>
    )
};

export default Router